/* eslint-disable func-call-spacing */
const Index = () => import('~pages/Validation/Index.vue')
const Validation = () => import('~pages/Validation/Validation.vue')

export default [
  {
    path: 'validation',
    component: Index,
    meta: {
      access: ['org.document.bulkApprove']
    },
    children: [
      {
        name: 'validation',
        path: '/',
        component: Validation,
        meta: {
          access: ['org.document.bulkApprove']
        }
      }
    ]
  }
]
